<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-lms-history-data [history]='history?.history' [historyOps]='historyOps' [scrollHeight]='commonHistoryHeight' [isBackToTop]="false" [upperHeight]='upperHeight'></lms-lms-history-data>
<lms-thp-history-data [history]='history?.thpHistory' [scrollHeight]='thpHistoryHeight' [upperHeight]='upperHeight + commonHistoryHeight'></lms-thp-history-data>